import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=0fbb44d1&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports